<div>
  <div class="border-b border-gray-100 p-3 md:p-4">
    <mat-card-title class="!flex items-center justify-between w-full">
      <div class="flex items-center space-x-2">
        <mat-icon class="text-blue-500">work</mat-icon>
        <span class="text-xl font-semibold text-gray-800">Career Details</span>
      </div>
      @if (showCloseButton) {
      <button (click)="close()" mat-icon-button class="text-gray-500 hover:text-gray-700 transition-colors">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      }
    </mat-card-title>
  </div>

  <div class="p-3 md:p-4">
    <div class="space-y-4">
      <!-- Last Worked Company -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start space-x-3">
          <mat-icon class="text-blue-500 min-w-fit">business</mat-icon>
          <div class="w-full">
            <h3 class="text-sm font-medium text-gray-500">Work Experience</h3>
            <div class="w-full divide-y-1">
              @for(company of candidate?.resume_analysis?.resume_analysis?.work_experience;track $index) {

                <div class="my-4 p-3 md:p-4 rounded-lg border border-gray-200 transition-shadow">
                  <div class="space-y-4 w-full">
                    <!-- Company Name Section -->
                    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center pb-3 border-b border-gray-200">
                      <span class="text-sm font-medium text-gray-500 mb-1 sm:mb-0">Company Name</span>
                      <span class="text-gray-800">{{company?.company_name || 'Not Stated'}}</span>
                    </div>

                    <!-- Role Section -->
                    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center pb-3 border-b border-gray-200">
                      <span class="text-sm font-medium text-gray-500 mb-1 sm:mb-0">Role</span>
                      <span class="text-gray-800">{{company?.job_title || 'Not Stated'}}</span>
                    </div>

                    <!-- Experience Section -->
                    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                      <span class="text-sm font-medium text-gray-500 mb-1 sm:mb-0">Experience</span>
                      <span class="text-gray-800">
                        <span>{{company?.total_years_experience || 'Not Stated'}}</span>
                        <span class="text-gray-600" *ngIf="company?.total_years_experience"></span>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="flex items-center my-6 w-full">
                  <div class="flex-grow border-t border-gray-200"></div>
                  <div class="px-3 flex space-x-1">
                    <div class="w-1.5 h-1.5 rounded-full bg-blue-300"></div>
                    <div class="w-1.5 h-1.5 rounded-full bg-blue-400"></div>
                    <div class="w-1.5 h-1.5 rounded-full bg-blue-500"></div>
                    <div class="w-1.5 h-1.5 rounded-full bg-blue-400"></div>
                    <div class="w-1.5 h-1.5 rounded-full bg-blue-300"></div>
                  </div>
                  <div class="flex-grow border-t border-gray-200"></div>
                </div>
              <!-- <p class="text-gray-800 font-semibold mt-1">{{company.company_name }}</p> -->
              <!-- <div class="p-4 w-full my-2 bg-gray-50 rounded-lg shadow-sm border border-gray-100">
                <div class="border-b border-gray-200 pb-3 mb-4">
                  <h1 class="text-lg font-semibold text-gray-800">{{company?.company_name}}</h1>
                </div>

                <div class="grid grid-cols-2 gap-6">
                  <div class="flex flex-col">
                    <div class="text-gray-500 text-sm font-medium mb-1">Role</div>
                    <div class="text-gray-800">{{company?.job_title}}</div>
                  </div>

                  <div class="flex flex-col">
                    <div class="text-gray-500 text-sm font-medium mb-1">Experience</div>
                    <div class="text-gray-800">{{company?.total_years_experience}}</div>
                  </div>
                </div>
              </div> -->
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Industry Experience -->
      <!-- <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start gap-3">
          <mat-icon class="text-blue-500 min-w-fit">trending_up</mat-icon>
          <div>
            <h3 class="text-sm font-medium text-gray-500">Industry Experience</h3>
            <p class="text-gray-800 mt-1">{{ getTotalExperience() }}</p>
          </div>
        </div>
      </div> -->

      <!-- Skills -->
      <div class="bg-gray-50 rounded-lg p-3 md:p-4 transition-colors">
        <div class="flex items-start space-x-3">
          <mat-icon class="text-blue-500 min-w-fit">stars</mat-icon>
          <div class="w-full">
            <h3 class="text-sm font-medium text-gray-500">Top Skills</h3>
            <div class="mt-3 flex flex-wrap gap-2">
              <div *ngFor="let skill of candidate?.resume_analysis?.resume_analysis?.skills"
                class="flex items-center gap-2 p-2 rounded-lg my-1 bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors">
                <mat-icon class="h-4 w-4 mr-1">check_circle</mat-icon>
                <span class="my-auto">{{ skill }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
